<template>
  <div>
    <Cabecera :usu="usuario" :contrato="contrato"/>
    <!-- Autorizacion  -->
      <v-dialog v-model="enddialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Advertencia</v-card-title>
        <v-card-text>El usuario no esta Autorizado para ver este Modulo...</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="$router.go(-1)">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin Autorizacion -->
  
    <v-dialog v-model="d_mensualidad" transition="dialog-bottom-transition" max-width="400" persistent>
      <v-card rounded="xl">
          <v-card-title>
              SERVICIO SUSPENDIDO
              <v-spacer></v-spacer>
              <v-icon @click="goLogin()">close</v-icon>
          </v-card-title>
          <v-card-text>
              <v-row>
                  <v-col cols="12" class="text-center">
                      <span class="text-body-2">
                          Tú servicio se encuentra suspendido.<br>
                          comunicate con soporte
                      </span>
                  </v-col>
              </v-row>
          </v-card-text>
      </v-card>
    </v-dialog>
 </div>
</template>

<script>
import Cabecera from '@/components/Cabecera.vue';
import axios from 'axios'
export default {
  name: 'Home',
  components: { Cabecera },
  data(){
    return{
      enddialog:false,
      usuario:'',
      contrato:'',
      d_mensualidad:false,
      intervaloId:0,
    }
  },
  async mounted(){
   this.Autorizacion();
   await this.validaMensualidad();
  },
  methods:{
    Autorizacion(){
      this.usuario = this.$route.params.idUsuario;
      this.contrato = this.$route.params.idContrato;
      console.log(this.usuario,this.contrato);
      if (this.usuario === undefined || this.usuario.trim()==''){
          this.enddialog=true;          
      }
      if (this.contrato === undefined || this.contrato.trim()==''){
          this.enddialog=true;          
      }
    },
    async validaMensualidad(){
        try {
            console.log('Validar Mensualidad', this.contrato);
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/token/access/' + this.contrato);
            const datos = response.data;
            if (datos[0].existe=='no'){ 
                this.d_mensualidad=true;
                console.log('Finalizado')
            } else {
              // 12 horas en milisegundos: 12 * 60 * 60 * 1000 = 43200000
              const horas = 3;
              const intervalo = parseFloat(horas) * 60 * 60 * 1000;
              setTimeout(() => { this.validaMensualidad() }, intervalo);
            }
        } catch (error) {
            console.log(error)
        }
    },
    goLogin(){
      this.d_mensualidad=false;
      this.$router.push({name:'Login'});
    }
  }
}
</script>
